"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const font_1 = require("./font");
const typography = {
    fonts: {
        family: font_1.fontFamily,
        size: font_1.fontSizes,
        weight: font_1.fontWeights
    },
    lineHeights: font_1.lineHeights
};
exports.default = typography;
//# sourceMappingURL=typography.js.map